module.exports = __webpack_public_path__ + "static/img/rank_235.f01c371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_235.png
// module id = 6zea
// module chunks = 1